<template>
  <div class="collectionPoint-management width-responsiveness--centralized">
    <div class="collectionPoint-management__container">
      <collectionPoint-create-modal ref="collectionPointCreateModal" />
      <subheader
        title="Postos de coleta"
        :centralized="true"
        :back-button-visible="true"
      >
        <div class="search-box-container">
          <input
            v-model="filterInput"
            class="search-box__input"
            placeholder="Pesquisar..."
          >
          <img
            class="search-box__icon"
            src="/static/images/icon-search-small.svg"
          >
        </div>
        <button
          id="btnAddNewcollectionPoint"
          class="btn btn-primary btn-regular-size"
          @click="openModal()"
        >
          <img src="/static/images/icon-plus.svg">
          Novo posto de coleta
        </button>
      </subheader>

      <div class="collectionPoint-management__container">
        <collectionPoint-list :filter-input="filterInput" />
      </div>
    </div>
    <page-scroll-top />
  </div>
</template>

<script>
import CollectionPointList from './CollectionPointList'
import CollectionPointCreateModal from './CollectionPointCreateModal'
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'
import { mapActions } from 'vuex'

export default {
  name: 'CollectionPointManagement',
  components: {
    subheader: SubHeader,
    'collectionPoint-list': CollectionPointList,
    'collectionPoint-create-modal': CollectionPointCreateModal,
    'page-scroll-top': PageScrollTop
  },
  data: () => {
    return {
      filterInput: ''
    }
  },
  methods: {
    ...mapActions(['getAllCollectionPointList']),
    openModal () {
      this.$nextTick(function () {
        this.$refs.collectionPointCreateModal.openModal()
      })
    }
  },
  mounted () {
    this.getAllCollectionPointList()
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/mixins";

.collectionPoint-management {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 150px;

  &__container {
    width: 100%;
  }

  button {
    svg {
      height: 0.6em;
    }
  }

  .subheader__content__right-side {
    display: flex;
    align-items: center;

    .search-box {
      &-container {
        display: flex;
        background-color: white;
        border-radius: 3px;
        padding: 0.5em 0.3em 0.5em 1em;
        margin-right: 1em;
      }

      &__input {
        background-color: white;
        border: 0;
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        color: #4a4a4a;

        &::placeholder {
          color: #7a7a7a;
        }

        &:focus {
          border: 0;
          outline: none;
        }
      }

      &__icon {
        svg {
          width: 0.7em;
          height: 0.7em;

          path {
            fill: #7f1a54;
          }
        }
      }
    }
  }
}
</style>
